/**
 * Created by mqamhieh on 12/28/16.
 */
(function (app) {

    app.controller('ManageLaneTemplatesModal', [
        '$scope', 'hTransitions', 'modalData', 'Upload', '$q', '$state', 'onClose',
        function ($scope, hTransitions, modalData, Upload, $q, $state, onClose) {

            var firstBack = true;

            $scope.close = function () {

                var deffer = $q.defer();

                $scope.amsManageLaneTemplatesForm.confirmDiscard()
                    .then(function () {
                        deffer.resolve();
                        close();
                        $scope.$digest();

                    }, function () {
                        deffer.reject();
                    });

                return deffer.promise;
            };

            $scope.amsManageLaneTemplatesForm = new AMSManageLaneTemplatesForm($scope, {
                jobId: modalData.jobId,
                brandId: modalData.brandId,
                type: (modalData.type || 'job'),
                interviewTemplate: !!modalData.interviewTemplate,
                interviewType: modalData.interviewType || 'INVITE',
                interviewCategory: modalData?.interviewCategory,
                positionCode: modalData?.positionCode
            }, Upload);

            function close () {
                if (onClose) {

                    var templates = $scope.amsManageLaneTemplatesForm.templates.filter(function (template) {
                        return template.id;
                    });

                    onClose(templates);
                }
                $scope.$hide();
            }

            $scope.amsManageLaneTemplatesForm.on('done', function () {
                close();
                unhookTransitionStart();
                $scope.$digest();
            });

            $scope.amsManageLaneTemplatesForm
                .load(modalData.laneId)
                .then(function () {

                    if (modalData.startTemplate) {
                        $scope.amsManageLaneTemplatesForm.setNewTemplateData(modalData.startTemplate);
                    }

                    $scope.$digest();
                });

            // When Location change 'like pressing back button' close the modal
            var unhookTransitionStart = hTransitions.onStart({}, function (trans) {
                var next = trans.to();

                if (firstBack) {
                    $scope.close().then(function () {
                        firstBack = false;
                        $state.go(next.name);
                    });
                    return false;
                }
            });

        }]);
})
(angular.module('harriApp'));